import axios from '@axios'

export default {
  loadAll() {
    return axios.get('/financeiro/configuracao-gateway')
  },
  loadById(id) {
    return axios.get(`/financeiro/configuracao-gateway/${id}`)
  },
  insert(data) {
    return axios.post('/financeiro/configuracao-gateway', data)
  },
  update(id, data) {
    return axios.put(`/financeiro/configuracao-gateway/${id}`, data)
  },
  delete(id) {
    return axios.delete(`/financeiro/configuracao-gateway/${id}`)
  },
}
